import { useSuspenseQuery } from '@tanstack/react-query';
import { useToast } from '@givebutter/primitives/toast';
import { fetchCompanyContacts } from 'api/contacts/companies';
import * as DropdownMenu from 'components/dropdown-menu';
import { useCopy } from 'components/snippet';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { useCurrentContact } from 'customHooks/useCurrentContact';
import { accountQueryKeys } from 'queries/account-query-keys';

const CopyAllEmails = (props: DropdownMenu.DropdownMenuItemProps) => {
    const { onClick, ...rest } = props;
    const { data: company } = useCurrentContact();
    const { accountId } = useCurrentAccount();
    const { success } = useToast();
    const { onClickCopy } = useCopy({
        onCopy: () => success('All contact emails have been copied to clipboard'),
    });

    const { data } = useSuspenseQuery({
        queryKey: accountQueryKeys.companyContacts(accountId, company.id),
        queryFn: async () => {
            return fetchCompanyContacts(accountId, company.id, {
                page: 1,
                per_page: 9999,
            });
        },
    });

    const copyAllEmails = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.stopPropagation();
        const emailList = data?.data
            .map(contact => contact.contact.primary_email)
            .filter(Boolean)
            .join('\n');
        onClickCopy(e, emailList);
    };

    return (
        <DropdownMenu.Item
            onClick={e => {
                copyAllEmails(e);
                onClick?.(e);
            }}
            {...rest}
        />
    );
};

export { CopyAllEmails };
